<template>
	<Modal v-bind="$attrs" v-on="$listeners" :xIconDisabled="true" @closed="closed">
		<!-- 閉じる -->
		<div class="ml-auto w-fit mb-1 mr-1">
			<PrimaryButton text="閉じる" size="normal" @click="$emit('closed')"/>
		</div>
		<div v-if="target&&target.userName" class="overflow-auto w-fit px-3">
			<div class="font-bold text-blue-700 text-center">{{ getPeriod(target.year) }} {{ target.period==1?'上期':'下期' }}</div>
			<div class="font-bold text-blue-700 mb-4 text-center p-1">{{ target.userName }} さん<span class="pl-2 text-sm">（グループ {{ target.groupNum }}）</span></div>

			<div v-if="isDisp" class="flex flex-wrap items-stretch">
				<div v-if="!target.naBonus" class="min-w-200 mx-auto">
					<div class="mt-2 font-bold border-b border-gray-300 text-center">
						<span class="pr-5">賞与総額</span>
						<span>{{ target.bonusTotal ? target.bonusTotal.toLocaleString() : 0 }} 円</span>
					</div>
					<!-- 賞与内訳 -->
					<div class="p-2 border rounded border-blue-300 mt-4 text-sm">
						<!-- <div class="font-bold text-blue-500 mb-2 text-sm">詳細</div> -->
						<div class="text-gray-800">

							<!-- 本来の賞与 -->
							<div class="bg-blue-50 rounded p-2 w-full mb-5 whitespace-nowrap">
								<div class="border border-indigo-500 rounded-3xl text-center  text-xs font-bold text-indigo-600"> {{ target.groupNum }} G</div>

								<div class="flex gap-2 mt-2">
									<div class="flex-1 font-bold text-indigo-700">{{ target.rankName }} 評価</div>
									<div class="flex-1"> {{ info.point }} ポイント</div>
								</div>
								<div class="flex gap-2 mt-2">
									<div class="flex-1 font-bold text-indigo-700">単価</div>
									<div class="flex-1"> {{ info.price }} 円</div>
								</div>

								<div class="flex gap-2 my-1 p-2 bg-indigo-100">
									<div class="flex-1 font-bold text-indigo-700">賞与額</div>
									<div class="flex-1 font-bold text-gray-700 text-right"> {{ target.bonus.toLocaleString() }} 円</div>
								</div>

								<div class="font-bold text-center">＋</div>
								<div class="flex gap-2 my-1 p-2 bg-indigo-100">
									<div class="flex-1 font-bold text-indigo-700">禁煙手当</div>
									<div class="flex-1 font-bold text-gray-700 text-right"> {{ maxSmoking.toLocaleString() }} 円</div>
								</div>
								<div class="font-bold text-center">＋</div>
								<div class="flex gap-2 my-1 p-2 bg-indigo-100">
									<div class="flex-1 font-bold text-indigo-700">安全運転手当</div>
									<div class="flex-1 font-bold text-gray-700 text-right"> {{ maxSafely.toLocaleString() }} 円</div>
								</div>
								<div class="font-bold text-center">⇩</div>
								<div class="flex gap-2 my-1 p-2 bg-indigo-100">
									<div class="flex-1 font-bold text-indigo-700">満額</div>
									<div class="flex-1 font-bold text-gray-700 text-right"> {{ (maxPrice).toLocaleString() }} 円</div>
								</div>
							</div>

							<!-- マイナス分 -->
							<div v-if="minusList.length">
								<div class="font-bold text-indigo-700 text-center">**満額との差分詳細**</div>
								<div v-for="(m, i) in minusList" :key="'m'+i" class="py-1.5 border-b border-dotted border-gray-400">
									<div class="flex justify-between">
										<div class="text-indigo-700">{{ m.title }}</div>
										<div class="whitespace-pre-line">{{ m.minus }}</div>
									</div>
									<div v-if="m.changed" class="text-xs font-bold text-gray-600 text-right">※総務により変更</div>
									<div v-if="m.detail" class="text-xs font-bold text-gray-600 text-right">{{ m.detail }}</div>
								</div>
								<div class="flex justify-between pt-2 text-indigo-700 font-bold">
									<div>合計差額</div>
									<div>{{ totalDiff }}</div>
								</div>
							</div>
							<!-- マイナス無し -->
							<div v-else class="font-bold text-indigo-700 text-center">
								**満額支給です**
							</div>

							<!-- その他詳細 -->
							<div v-if="detail.length" class="mt-5">
								<div class="font-bold text-green-700 text-center">**詳細（金額影響なし）**</div>
								<div v-for="(d, i) in detail" :key="'d'+i" class="py-1 flex justify-between text-xs font-bold text-gray-600">
									<div>{{ d.title }}</div>
									<div v-if="d.changed">総務により変更</div>
									<div v-if="d.detail">{{ d.detail }}</div>
								</div>
							</div>
						</div>
					</div>

					<div class="mt-5 text-sm font-bold text-gray-600">
						50期上期より、反省文3枚で始末書1枚相当
					</div>
				</div>

				<div v-else class="mx-auto my-10 w-fit font-bold">
					{{ target.year }}年度 {{ target.period==1?'上期':'下期' }} は評価判定のみ行います。
				</div>

				<div class="mt-3 mx-2 p-1 bg-green-50 rounded text-center" :class="!isMobileDevice?'ml-10':''">
					<div v-if="(boss||admin)&&loginUser.id!=target.userId" class="text-red-700 border-b border-red-700 w-fit mt-2 font-bold text-sm">「面談完了ボタン」を押した後でも<br>半年以内は「昇格・降格」 「メモ」は更新できます。</div>
					<div v-if="(boss||admin)&&loginUser.id!=target.userId" class="text-gray-700 text-center mt-2 font-bold text-sm">*本人にメモの内容は表示されません*</div>

					<!-- 直近3回の評価 -->
					<div class="p-2  mt-4 text-sm">
						<div class="font-bold text-blue-500 mb-2">直近3回評価</div>
						<div class="">
							<div v-if="info.pastPeriodId3" class="text-right text-indigo-700 text-sm underline cursor-pointer" @click="toEvaluationForm(info.pastPeriodId3)">評価シート</div>
							<div class="p-2 border border-blue-500 m-1 rounded">
								<div class="text-blue-700 font-bold">{{ rankCol[0] }}</div>
								<div v-if="!target.rankName3" class="text-center text-gray-800 text-sm mt-2">なし</div>
								<div v-else class="font-bold text-center mt-1 text-base">{{ target.rankName3 }}</div>
								<div class="font-bold text-center mt-1">{{ target.promotionRes3 }}</div>
								<div v-if="target.note3&&loginUser.id!=target.userId" class="whitespace-pre-line text-sm">{{ target.note3 }}</div>
							</div>

							<div class="mx-auto text-blue-800 w-fit">▼</div>

							<div v-if="info.pastPeriodId2" class="text-right text-indigo-700 text-sm underline cursor-pointer" @click="toEvaluationForm(info.pastPeriodId2)">評価シート</div>
							<div class="p-2 border border-blue-500 m-1 rounded">
								<div class="text-blue-700 font-bold">{{ rankCol[1] }}</div>
								<div v-if="!target.rankName2" class="text-center text-gray-800 text-sm mt-2">なし</div>
								<div class="font-bold text-center mt-1 text-base">{{ target.rankName2 }}</div>
								<div class="font-bold text-center mt-1">{{ target.promotionRes2 }}</div>
								<div v-if="target.note2&&loginUser.id!=target.userId" class="mt-1 whitespace-pre-line text-sm">{{ target.note2 }}</div>
							</div>

							<div class="mx-auto text-blue-800 w-fit">▼</div>

							<div class="text-right text-indigo-700 text-sm underline cursor-pointer" @click="toEvaluationForm(target.periodId)">評価シート</div>
							<div class="p-2 bg-blue-50 m-1 rounded border-2 border-blue-500">
								<div class="text-blue-700 font-bold">{{ rankCol[2] }}</div>
								<div class="font-bold text-center text-lg">{{ target.rankName }}</div>
								<div v-if="[1, 2].includes(target.groupNum)" class="text-sm text-gray-700 font-normal text-center mt-2">順位：{{ target.rankNum }} 位 / {{ target.groupCount }} 人中（1G・2G合算）</div>
								<div v-else class="text-sm text-gray-700 font-normal text-center mt-2">グループ内順位：{{ target.rankNum }} 位 / {{ target.groupCount }} 人中</div>

								<div class="font-bold text-green-700 text-center mt-3">評価した上司：{{ info.boss }}</div>

								<!-- 昇格、降格 -->
								<div class="mt-4 w-full">
									<div class="mb-1 font-bold text-xs text-gray-700">昇格・降格</div>
									<select
										v-model="target.promotion"
										class="border-gray-300 rounded focus:ring-indigo-500 focus:border-indigo-500 block w-full font-bold"
										:disabled="(!boss&&!admin)||(loginUser.id==target.userId)||timeOver"
										@change="changeValue('promotion')"
									>
										<option
											v-for="row in promotionList" :key='row.id'
											:value="row.id"
											class="">
											{{ row.name }}
										</option>
									</select>
								</div>
								<!-- 備考（本人には非表示） -->
								<div v-if="loginUser.id!=target.userId" class="mt-4 w-full">
									<textarea
										:rows="2"
										placeholder="メモ（次回面談の際に表示されます。本人には表示されません。）"
										class="text-gray-700 w-full border-gray-300 rounded text-sm"
										v-model="target.note"
										:disabled="!boss&&!admin||timeOver"
										@change="changeValue('note')"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="!notEdit" class="mt-4 mx-1 mb-1">
				<div v-if="!boss&&(!interviewCheck||target.changing2)" class="mb-2 text-center">
					上司が面談完了ボタンを押した後に押してください。
				</div>

				<PrimaryButton v-if="boss&&(!interviewDate||target.changing1)" text="面談完了" size="normal w-full" class="" @click="endBtn()"/>

				<div v-else-if="boss&&interviewDate" class="text-green-700 text-sm text-center">面談済み</div>

				<PrimaryButton v-else-if="!boss&&(!interviewCheck||target.changing2)" text="面談完了" size="normal w-full" class="" @click="checkBtn()"/>

				<div v-else-if="!boss&&interviewCheck" class="text-green-700 text-sm text-center">面談済み</div>

				<div class="text-xs text-red-600 text-center">{{ msg }}</div>
			</div>

			<div class="ml-auto w-fit mt-3 mb-1 mx-1">
				<PrimaryButton v-if="notEdit||(boss&&interviewDate&&!target.changing1)||(!boss&&interviewCheck&&!target.changing2)" text="閉じる" size="normal" @click="$emit('closed')"/>
			</div>
		</div>
	</Modal>
</template>

<script>
import Modal from '@components/Modal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import * as backend from '@libs/backend'
import * as dialogs from '@libs/dialogs'
import * as utils from '@libs/utils'
import * as moment from 'moment'
import * as logManager from '@managers/logManager'
import { FOUNDED } from '@/config'

export default {
	components: {
		Modal,
		PrimaryButton,
		// TrashIcon,
		// PlusCircleIcon
	},

	props: ['open', 'target', 'rankCol'],

	data() {
		return {
			reload: 0,
			// 上司
			boss: false,
			// 管理者
			admin: false,
			// 編集不可
			notEdit: true,
			// 昇格・降格候補
			promotionList: [
				{ id: null, name: 'なし' },
				{ id: 1, name: '昇格チャレンジ（未定）' },
				{ id: 2, name: '昇格チャレンジ 確定' },
				{ id: 3, name: '昇格（未定）' },
				{ id: 4, name: '昇格 確定' },
				// { id: 5, name: '拒否' },
				{ id: 7, name: 'チャレンジ 拒否' },
				{ id: 8, name: '確定 拒否' },
				{ id: 6, name: '降格' },
			],
			// 面談完了日時
			interviewDate: null,
			// 確認完了日時
			interviewCheck: null,
			// 確認ボタン催促メッセ
			msg: null,
			interval: null,
			// 表示・非表示
			isDisp: false,
			// ポイント、グループ単価など
			info: {},
			// 対象日よりも8か月以上たったら編集不可（上期は同年10月までOK、下期は3月までOK）
			timeOver: false,
			// 禁煙手当
			maxSmoking: 50000,
			// 安全運転手当MAX金額
			maxSafely: 0,
			// 満額
			maxPrice: 0,
			// マイナス分の詳細
			minusList: [],
			// 合計差分
			totalDiff: 0,
			// その他詳細
			detail: []
		}
	},

	mounted() {
		// 10秒おきに反映
		this.interval = setInterval(() => {
		this.getInterviewDate()
		}, 10000)
	},

	destroyed() {
		// 10秒おきの反映終了
		clearInterval(this.interval)
	},

	computed: {
		loginUser() {
			return this.$store.getters.user
		},

		isMobileDevice() {
			return utils.deviceInfo.isMobile
		},
	},

	watch: {
		open() {
			if (this.open) {
				this.getData()
			}
		},
	},

	methods: {
		/**
		 * モーダルclose
		 */
		closed() {
			// 面談上司
			this.boss = false
			// 編集不可
			this.notEdit = true
			// 管理者権限
			this.admin = false
			// 面談完了日時
			this.interviewDate = null
			// 確認完了日時
			this.interviewCheck = null
			// 確認ボタン催促メッセ
			this.msg = null
			this.interval = null
			// 表示・非表示
			this.isDisp = false
			// グループ単価、ポイントなど
			this.info = {},
			// 編集不可期間
			this.timeOver = false
			// 安全運転手当MAX金額
			this.maxSafely = 0
			// 満額
			this.maxPrice = 0
			// マイナス分の詳細
			this.minusList = []
			// 合計差分
			this.totalDiff = 0
			// その他詳細
			this.detail = []
		},

		/**
		 * データ取得
		 */
		async getData() {
			if (this.target) {
				// console.log(this.target)
				this.isDisp = false
				// 本人
				if (this.loginUser.id == this.target.userId) {
					this.boss = false
					this.notEdit = false

					// 面談完了した場合
					if (this.target.interviewCheck) {
						this.isDisp = true
					}

				// 賞与面談上司なのか確認
				} else if (this.target.juniorFlg) {
					this.boss = true
					this.notEdit = false
					this.isDisp = true
					// 面談
					this.interviewDate = this.target.interviewDate

				// それ以外は、「全員」表示している場合
				} else {
					this.notEdit = true
					this.isDisp = true
				}

				// 管理者
				let auth = this.$store.getters.auth
				if (auth && auth.adminAuth) {
					this.admin = true
				}

				// 確認完了
				this.interviewCheck = this.target.interviewCheck

				// 今日から8か月前
				const eightMonthsAgo = moment().subtract(8, 'months').format('YYYY-MM-DD')
				const yy = this.target.year
				// 上期なら対象は2月
				let mm = '-02'
				// 下期なら対象は8月
				if (this.target.period == 2) {
					mm = '-08'
				}
				// 対象日
				const tarM = yy + mm + '-01'

				// 対象日が本日より8か月前の場合は編集不可
				if (eightMonthsAgo > tarM) {
					this.notEdit = true
					this.timeOver = true
				} else {
					this.timeOver = false
				}

				// ポイント、グループ単価を取得
				const param = {
					userId: this.target.userId,
					year: this.target.year,
					period: this.target.period,
					groupNum: this.target.groupNum,
					rankName: this.target.rankName,
					periodId: this.target.periodId
				}

				try {
					const res = await backend.searchData('evaluationBonusResult/getInterview', param)
					if (res.data.data) {
						// console.log(res.data.data)
						this.info = res.data.data
						if (this.info.price) {
							this.info.price = Number(this.info.price).toLocaleString()
						}
						if (this.info.dep && (this.info.dep.includes('ラウンド') || this.info.dep.includes('品質管理') || this.info.dep.includes('建物管理'))) {
							this.maxSafely = 30000
						} else {
							this.maxSafely = 15000
						}
					}
				} catch (error) {
					console.log('エラーが発生しました。一旦、閉じてください。\n' + error)
					return
				}

				// 満額
				this.maxPrice = this.target.bonus + this.maxSmoking + this.maxSafely

				// 禁煙変更あり
				const changeSM = (this.target.smoking != this.target.smokingDefault)
				let flgSM = false
				// 安全運転変更あり
				const changeD = (this.target.drivePrice != this.target.drivePriceDefault)
				let flgD = false
				// 始末書・反省文
				let flgA = false

				// マイナス分
				if (this.maxPrice != this.target.bonusTotal) {
					// 禁煙手当
					if (!this.target.smoking) {
						flgSM = true
						this.minusList.push({ title: '禁煙手当', minus: '▲ ' + (this.maxSmoking).toLocaleString() + ' 円', changed: changeSM })
					}

					// 安全運転
					const drive = (this.target.drivePrice || 0)
					if (this.maxSafely > drive) {
						flgD = true
						const deiffDrive = (drive - this.maxSafely) * -1
						if (this.maxSafely == 30000 && drive == 15000 && this.info.selfDrive) {
							this.minusList.push({ title: '安全運転手当', minus: '▲ ' + (deiffDrive).toLocaleString() + ' 円', detail: '※基準距離（30L）未達の自己申告' })
						} else {
							this.minusList.push({ title: '安全運転手当', minus: '▲ ' + (deiffDrive).toLocaleString() + ' 円', changed: changeD })
						}
					}

					// 始末書・反省文
					if (this.target.apology || this.target.reflect) {
						// マイナス発生
						if (this.info.divideApology) {
							flgA = true
							const det = []
							if (this.target.apology) {
								det.push('始末書：' + this.target.apology)
							}
							if (this.target.reflect) {
								det.push('反省文：' + this.target.reflect)
							}
							this.minusList.push({ title: '始末書・反省文', minus: this.info.divideApology + '分の1', detail: '（' + det.join('、') + '）' })
						}
					}

					// 週休3日制
					if (this.target.weeklyHolidayDenominator) {
						this.minusList.push({ title: '週休3日制', minus: this.target.weeklyHolidayDenominator + '分の' + this.target.weeklyHolidayNumerator })
					}

					// その他、係数
					if (this.target.denominator) {
						this.minusList.push({ title: '時短・休職など', minus: this.target.denominator + '分の' + this.target.numerator })
					}

					// 差分合計
					this.totalDiff = '▲ ' + ((this.target.bonusTotal - this.maxPrice) * -1).toLocaleString() + '円'
				}

				// 禁煙変更あり、差分非表示
				if (changeSM && !flgSM) {
					this.detail.push({ title: '禁煙手当', changed: changeSM })
				}
				// 安全運転変更あり、差分非表示
				if (changeD && !flgD) {
					this.detail.push({ title: '安全運転手当', changed: changeD })
				}
				// 始末書・反省文あり、差分非表示
				if (!flgA) {
					if (this.target.apology) {
						this.detail.push({ title: '始末書', detail: this.target.apology + '枚' })
					}
					if (this.target.reflect) {
						this.detail.push({ title: '反省文', detail: this.target.reflect + '枚' })
					}
				}
			}
		},

		/**
		 * 昇格、降格、備考の変更
		 */
		async changeValue(tar) {
			const param = {
				loginUser: this.loginUser.id,
				periodId: this.target.periodId,
				targetName: tar,
				value: this.target[tar]
			}
			await backend.postData('evaluationBonusResult/changeValue', param)
		},

		/**
		 * 面談終了
		 */
		async endBtn() {
			const res = await dialogs.showConfirmDialog('終了してよろしいですか？', '5分以内に部下本人も「面談完了」ボタンを押さなければなりません。')
			if (res != 'YES') {
				return
			}
			const param = {
				loginUser: this.loginUser.id,
				loginUserName: utils.deleteKana(this.loginUser.user_name),
				periodId: this.target.periodId
			}
			await backend.postData('evaluationBonusResult/saveInterviewer', param)
			this.interviewDate = moment().format('YYYY-MM-DD')
			let per = '上期'
			if (this.target.period == 2) {
				per = '下期'
			}
			logManager.recording(this, logManager.Loglevel.INFO, '賞与面談', '面談終了', this.target.year + '年度' + per + ':' + this.target.userName + ' の賞与面談を完了しました。')
			this.$emit('closed')
		},

		/**
		 * 面談本人確認
		 */
		async checkBtn() {
			const param = {
				periodId: this.target.periodId
			}
			const res = await backend.postData('evaluationBonusResult/saveInterviewCheck', param)
			if (res.data.data) {
				alert(res.data.data + '完了できません。')
				return
			}
			this.interviewCheck = moment().format('YYYY-MM-DD')
			let per = '上期'
			if (this.target.period == 2) {
				per = '下期'
			}
			logManager.recording(this, logManager.Loglevel.INFO, '賞与面談', '確認完了', this.target.year + '年度' + per + 'の賞与面談を確認完了しました。')
			this.$emit('closed')
		},

		/**
		 * 面談完了日時取得
		 */
		async getInterviewDate() {
			// 本人の場合のみ
			if (!this.boss && !this.notEdit && !this.interviewCheck && !this.target.changing1) {
				const param = {
					periodId: this.target.periodId
				}
				const res = await backend.searchData('evaluationBonusResult/getInterviewDate', param)
				if (res.data.data) {
					const time = res.data.data
					// 制限時間5分後
					const limit = moment(time).add(5, 'minutes')
					// 現在
					const ima = moment()

					// 5分以内の場合
					if (ima.isSameOrBefore(limit, 'minute')) {
						const msg = moment(limit).format('HH時mm分') + 'までに「確認完了」ボタンを押してください。'
						if (!this.interviewDate) {
							alert(msg)
						}
						this.msg = msg
					}
					this.interviewDate = time
				}
			}
		},

		/**
		 * 期を取得
		 * @param year 対象年度
		 */
		getPeriod(year) {
			if (year) {
				return (Number(year) - FOUNDED) + ' 期'
			}
			return ''
		},

		/**
		 * 評価シート遷移
		 * @param id 評価シート
		 */
		toEvaluationForm(id) {
			const target = {
				year: this.target.year,
				period: this.target.period,
				userName: this.target.userName,
				userId: this.target.userId,
			}
			const tar = JSON.stringify(target)
			sessionStorage.setItem('FROM_BONUS_TO_EVALUATION', tar)
			let route = this.$router.resolve({
				name: 'EvaluationInput',
				query: {
					id,
					mode: 'view'
				}
			});
			window.open(route.href, '_blank')
		},
	}
}
</script>
<style scoped>
.grid-form1 {
	grid-template-columns: repeat(2, auto);
}
</style>